<template>
  <v-row justify="center">
    <v-dialog v-model="attivo" persistent max-width="900px">
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h5"
              >{{ $t("login.registrazioneUtente") }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-icon="mdi-email"
                    label="Email*"
                    v-model="form.email"
                    required
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  v-if="confermaRegistrazione"
                  class="animate__animated animate__fadeIn"
                >
                  <v-alert dense text type="success">{{
                    $t("login.registrazioneUtenteConferma")
                  }}</v-alert>
                </v-col>
                <v-col cols="12" v-if="EmailEsistente">
                  <v-alert dense outlined type="error">
                    {{ $t("login.registrazioneUtenteEmailEsistente") }}
                  </v-alert>
                </v-col>
                <v-col cols="12" v-if="erroreGenerale">
                  <v-alert dense outlined type="error">
                    Errore!!
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
            <small>({{ $t("campiObbligatori") }})</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              prepend-icon="mdi-email"
              color="primary"
              @click="checkLogin"
            >
              <i class="material-icons p-2">send</i>
              {{ $t("conferma") }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="chiudi">
              {{ $t("chiudi") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import api from '@/services/EventService.js'

export default {
  name: "NuovoUtente",

  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: function() {
    return {
      dialog: true,
      form: {email: null},
      confermaRegistrazione: false,
      EmailEsistente: false,
      erroreGenerale: false,
      rules: {
        required: (value) => {
          return !!value || this.$i18n.t("campoObbligatorio");
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$i18n.t("login.emailNonValida");
        },
      },
    };
  },
  methods: {
    async chiudi() {
      this.confermaRegistrazione = false;
      this.EmailEsistente = false;
      this.erroreGenerale= false;
      this.attivo = false;
      this.form.email= null;
      this.$emit("chiudiForm");
    },
    async checkLogin() {
      this.confermaRegistrazione = false;
      this.EmailEsistente = false;
      this.erroreGenerale = false;
      if (this.$refs.form.validate()) {
        // api creazione nuovo user
        
        
        api
          .post("/login/immatricolazioni/nuovoutente", this.form)
          .then((r) => {
            if(r.status=="200"){
                this.confermaRegistrazione = true;
                //alert(r.data)
            }
           if(r.response.status=="400"){
               this.EmailEsistente = true;
            }
           
            
          })
          .catch((error) => {

             if(error.response.status=="400"){
               this.EmailEsistente = true;
            }else
           {this.erroreGenerale = true}
            
            
          })
          

        //
      }
    },

    //
  },
  activated() {},
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
// Reversed input variant
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }
  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}

// Bonus "expand" variant
.v-input--expand .v-input__slot {
  // justify-content: space-between;
  .v-label {
    display: block;
    flex: 1;
  }
}
</style>
